import React from "react";
import { Globe } from "lucide-react";
import { Dropdown } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { useLangBtn } from "../../hooks/useLangBtn";

interface Language {
  code: "en" | "ar";
  label: string;
  nativeLabel: string;
}

const LangBtn: React.FC = () => {
  const {
    currentLang,
    isOpen,
    languages,
    handleLanguageSelect,
    setIsOpen,
    dropdownRef,
  } = useLangBtn();

  return (
    <Dropdown show={isOpen} ref={dropdownRef}>
      <Dropdown.Toggle
        variant="transparent"
        className="d-flex align-items-center gap-2 p-2 text-white "
        style={{ direction: currentLang === "ar" ? "rtl" : "ltr" }}
        onClick={() => setIsOpen(!isOpen)}
      >
        <Globe className="w-4 h-4" />
        <span>{currentLang === "en" ? "English" : "العربية"}</span>
      </Dropdown.Toggle>

      <Dropdown.Menu className="w-100">
        {languages.map((lang: Language) => (
          <Dropdown.Item
            key={lang.code}
            onClick={() => handleLanguageSelect()}
            active={currentLang === lang.code}
            className="d-flex justify-content-between align-items-center"
          >
            <span>{lang.nativeLabel}</span>
            {currentLang === lang.code && (
              <i className="bi bi-check2 text-primary"></i>
            )}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default LangBtn;
